import { FocusRingOverlay } from '../hooks/useFocus'

export const defaultOverlayRootName = 'default'

export function getOverlayRootElement(name = defaultOverlayRootName) {
  return document.querySelector<HTMLElement>(`[data-overlay-root-name="${name}"]`)
}

export type OverlayRootProps = {
  name?: string
}

export const OverlayRoot = (props: OverlayRootProps) => {
  const { name = defaultOverlayRootName } = props
  return (
    <div data-overlay-root-name={name}>
      <FocusRingOverlay />
    </div>
  )
}
